// "Book a free 15-minute call" (BRD No-GMB-profile / unverified edge cases).
// Set VITE_GMB_BOOKING_URL to the booking page; until then it opens an email.
export const GMB_BOOKING_URL: string =
  import.meta.env.VITE_GMB_BOOKING_URL || 'mailto:support@quantyraanalytics.com?subject=GMB%20setup%20help';
